class FeaturedCollectionsSlider {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.slider = document.getElementById(`Featured-collections-${this.sectionId}__slide`);
    this.prevButton = document.getElementById(`Featured-collections-${this.sectionId}__button-prev`);
    this.nextButton = document.getElementById(`Featured-collections-${this.sectionId}__button-next`);
    this.arrows = document.querySelectorAll(".featured-collections__arrow");

    if (this.slider) {
        this.initSlider();
        this.initArrowEvents();
        this.updateArrowPositions();
        
        // Listen for resize event with debounce
        window.addEventListener("resize", this.debounce(() => this.updateArrowPositions(), 200));
    }
  }

  initSlider() {
      $(this.slider).slick({
          dots: true,
          infinite: false,
          speed: 500,
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3000,
          arrows: false,
          responsive: [
              {
                  breakpoint: 1024,
                  settings: { slidesToShow: 3, infinite: true }
              },
              {
                  breakpoint: 750,
                  settings: { slidesToShow: 2, infinite: true }
              },
              {
                  breakpoint: 480,
                  settings: { slidesToShow: 1.5, centerMode: false }
              }
          ]
      });

      // Call update arrow position after each slide transition
      $(this.slider).on('afterChange', () => this.updateArrowPositions());
  }

  initArrowEvents() {
      if (this.prevButton) {
          this.prevButton.addEventListener("click", () => {
              $(this.slider).slick("slickPrev");
          });
      }

      if (this.nextButton) {
          this.nextButton.addEventListener("click", () => {
              $(this.slider).slick("slickNext");
          });
      }
  }

  updateArrowPositions() {
      const activeSlide = document.querySelector(".slick-slide.slick-current.slick-active");

      if (!activeSlide || this.arrows.length < 2) return;

      // Wait for Slick to update the size before taking it.
      setTimeout(() => {
          const slideWidth = activeSlide.getBoundingClientRect().width;
          const imageHeight = slideWidth;
          const arrowPosition = `${imageHeight / 2}px`;

          this.arrows.forEach(arrow => {
              arrow.style.top = arrowPosition;
          });
      }, 100); // Wait 100ms for Slick to update
  }

  // The debounce function reduces the number of update calls when resizing.
  debounce(func, wait) {
      let timeout;
      return function (...args) {
          const context = this;
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(context, args), wait);
      };
  }
}

// Initialize slider when page loads
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".custom-featured-collections").forEach(container => {
      new FeaturedCollectionsSlider(container);
  });
});
